/// ///////////////////////////////////////////////////////////////////////////////
// Copyright (C) 2026 CONQUER INNOVATIONS SP. Z O.O. Global B.V. and its affiliate(s).
// All rights reserved.
//
// This software and other materials contain proprietary information
// controlled by CONQUER INNOVATIONS SP. Z O.O. and are protected by applicable copyright legislation.
// Any use and utilization of this software and other materials and
// disclosure to any third parties is conditional upon having a separate
// agreement with CONQUER INNOVATIONS SP. Z O.O. for the access, use, utilization or disclosure of this
// software. In the absence of such agreement, the use of the software is not
// allowed.
// The creator, author and originator of the code in the current file: Michał Pawłowski
//////////////////////////////////////////////////////////////////////////////////
<template>
  <div class="card shadow-sm border-0 h-100">
    <div v-if="title" class="card-header bg-transparent border-bottom-0 pt-3 pb-0">
      <h5 class="card-title text-primary mb-0"><i class="bx bx-list-ul me-2"></i>{{ title }}</h5>
    </div><div class="card-body">
      <div class="mb-3">
        <label class="form-label text-muted small text-uppercase fw-bold">Dodaj nowy element</label>
        <div class="input-group">
          <input
              v-model="elementToAdd"
              type="text"
              :class="elementInputClass"
              :placeholder="elementInputPlaceholder || 'Wpisz wartość...'"
              class="form-control"
              @keydown.enter="addElement"
              aria-describedby="button-add"
          />
          <button
              class="btn btn-primary"
              type="button"
              id="button-add"
              @click="addElement"
              title="Dodaj do listy"
          >
            <i class="bx bx-plus"></i> Dodaj
          </button>

          <div class="invalid-feedback">
            Ten element jest już na liście lub jest nieprawidłowy.
          </div>
        </div>
      </div>

      <div class="list-container border rounded bg-light">
        <ul class="list-group list-group-flush" v-if="list && list.length > 0">
          <li
              v-for="(item, index) in list"
              :key="index"
              class="list-group-item d-flex justify-content-between align-items-center bg-transparent py-2"
          >
            <span class="text-truncate" :title="item">{{ item }}</span>
            <button
                class="btn btn-sm btn-outline-danger border-0 rounded-circle ms-2"
                @click="removeElement(item)"
                title="Usuń element"
            >
              <i class="bx bx-trash"></i>
            </button>
          </li>
        </ul>

        <div v-else class="text-center py-4 text-muted">
          <i class="bx bx-ghost fs-3 mb-2 d-block"></i>
          <span class="small">Brak elementów na liście</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MutableScrollableListView2",
  props: ["listContent", "title", "elementInputPlaceholder"],
  emits: ["onRemoveElement","onAddElement"],
  data() {
    return {
      elementToAdd: "", // SIC! Zachowana literówka z oryginału
      list: [],
      elementInputClass: "form-control",
    };
  },
  methods: {
    addElement(elem) {
      if (elem) {
        this.elementToAdd = elem.target.value;
      }
      if (this.checkForm()) {
        this.$emit("onAddElement", this.elementToAdd);
        this.elementToAdd = "";
        // Reset validation styling
        this.elementInputClass = "form-control";
      }
    },
    removeElement(element) {
      this.$emit("onRemoveElement", element);
    },
    checkForm() {
      var isValid = true;
      var notValidFieldsCount = 0;

      // Basic validation logic preserved
      if (this.elementToAdd == null || this.elementToAdd == undefined || this.elementToAdd.trim() === "") {
        this.elementInputClass = "form-control is-invalid";
        return false;
      }

      var elementAlreadyOnList = this.list.find(
          (elem) => elem === this.elementToAdd
      );

      if (elementAlreadyOnList != null && elementAlreadyOnList != undefined) {
        this.elementInputClass = "form-control is-invalid";
        notValidFieldsCount++;
      } else {
        this.elementInputClass = "form-control";
      }

      if (notValidFieldsCount > 0) {
        isValid = false;
      } else {
        isValid = true;
      }

      return isValid;
    },
  },
  watch: {
    // Watch prop change to sync list if parent updates it
    listContent: {
      handler(newVal) {
        if (newVal) {
          this.list = newVal;
        }
      },
      immediate: true
    }
  },
  created() {
    // Initialization logic preserved
    this.list = [];
    if(this.listContent !== undefined && this.listContent != null && this.listContent.length > 0){
      this.list = this.listContent;
    }
  },
};
</script>

<style scoped>
/* Custom Scrollbar dla kontenera listy */
.list-container {
  max-height: 250px;
  overflow-y: auto;
  /* Scrollbar styling for Webkit */
  scrollbar-width: thin;
  scrollbar-color: #ced4da #f8f9fa;
}

.list-container::-webkit-scrollbar {
  width: 6px;
}

.list-container::-webkit-scrollbar-track {
  background: #f8f9fa;
}

.list-container::-webkit-scrollbar-thumb {
  background-color: #ced4da;
  border-radius: 10px;
}

.card-title i {
  vertical-align: middle;
}
</style>